<template lang="pug">
  .Settings.card

    .page-tab
      .page-tab-list
        router-link.page-tab-link(
          :to="{ name: 'company' }"
          :data-text="$t('generic.field.company')")
        router-link.page-tab-link(
          :to="{ name: 'goal' }"
          :data-text="$t('generic.field.goal.p')")
        router-link.page-tab-link(
          :to="{ name: 'role' }"
          :data-text="$t('generic.field.role.p')")
    .body
      transition(name="settings-tab" mode="out-in")
        router-view

</template>

<script>

  import { mapGetters } from "vuex";

  export default {
    name: 'Settings',

    computed: {

    }
  }

</script>

<style lang="scss" scoped>
  .Settings {
    height: 100%;
  }

  .settings-tab {
    &-enter-active, &-leave-active {
      transition: $transition-fast;
    }

    &-enter, &-leave-to {
      opacity: 0;
    }

    &-enter {
      transform: translateX(5px);
    }

    &-leave-to {
      transform: translateX(-5px);
    }
  }

  .body {
    margin-top: 40px;
    height: 100%;
  }

  .page-tab {
    background-color: white;
    border-bottom: solid 1px #eaeef4;
    min-height: 60px;
    padding: 0px 41px;
    margin: -40px -40px 0px -40px;

    & .page-tab-link {
      padding: 21px inherit;
      height: 63px;
    }
  }
</style>
